import { useModuleAvailability } from 'modules/core/hooks/useModuleAvailability'
import hasFeature from 'modules/core/lib/hasFeature'

export const useModule = () => {
  const { loading, moduleAvailability } = useModuleAvailability('timeoff')

  if (hasFeature('dev_packaging_paywalls')) {
    return { loading: loading, enabled: moduleAvailability.available }
  }

  return { loading: false, enabled: hasFeature('time_off') }
}
